<template>
  <div class="bracelet-finder__progress-container">
    <div class="bracelet-finder__progress">
      <div
        class="bracelet-finder__progress-step"
        :style="{
          width: `${step / 3 * 100}%`
        }"
      />
    </div>
    <div class="bracelet-finder__progress-sub">
      <btn
        v-show="step >= 2"
        :label="isMobile ? $string('bracelet_finder.back') : $string('bracelet_finder.previous')"
        modifiers="text"
        @click="handlePrevious"
      />

      <span class="bracelet-finder__progress-counter text-other-label-medium">
        {{ step }}{{ $string('bracelet_finder.number_of_steps') }}
      </span>
    </div>
  </div>
</template>

<script>

/**
* Vue: Bracelet finder (bracelet-finder)
* -----------------------------------------------------------------------------
* Bracelet Finder Section based off of meta-object.
*
*
*/
import { mapState } from 'vuex'

import Btn from '~global/btn/btn'

export default {
  name: 'BraceletFinderProgressBar',

  components: {
    Btn,
  },

  props: {
    step: {
      type: Number,
      default: 1,
    },
  },

  emits: {
    'previous-step': (payload) => typeof payload === 'object',
  },

  computed: {

    /**
 * Map Vuex state.
 */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },

  methods: {
    handlePrevious() {
      const previousStep = this.step - 1
      const previousObject = {
        step: previousStep,
      }

      this.setNewUrl(previousStep)

      this.$emit('previous-step', previousObject)
    },

    setNewUrl(previousStep) {
      const urlParameters = new URLSearchParams(location.search)
      const selectedMetal = urlParameters.get('metal').replace('+', ' ')

      if (previousStep === 2) {
        urlParameters.forEach((value, key) => urlParameters.delete(key))
        urlParameters.delete('step')
        urlParameters.set('step', '2')
        urlParameters.set('metal', selectedMetal)
      }
      if (previousStep === 1) {
        urlParameters.delete('step')
        urlParameters.delete('metal')
      }

      const url = urlParameters.toString() === ''
        ? `${location.origin}${location.pathname}`
        : `${location.origin}${location.pathname}?${urlParameters.toString()}`

      history.pushState({
        html: '',
      }, '', url)
    },

  },
}
</script>

    <style lang="scss">
      @import './bracelet-finder';
    </style>
